import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import {ToastComponent} from '../../components/toast/toast.component';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Dictionary } from 'highcharts';


@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  public order;

  constructor(
    private httpClient: HttpClientService,
    private toastComponent: ToastComponent
  ) { }

  addItemActionToCart(userId: string, vendorProductId: string, itemAction: Dictionary<any>, showToast = false): Promise<any> {
    return this.httpClient.postToWallitApi(
      `/orders/users/${userId}/vendorProducts`,
      { itemAction },
      { params: new HttpParams().set('vendorProductId', vendorProductId) }
    ).toPromise().then((result) => {
      if (showToast) {
        this.toastComponent.presentToast('Added to cart.');
      }
      return result;
    });
  }

  addUserAttributesToCart(userId: string, userAttributes: Dictionary<any>): Promise<any> {
    return this.httpClient.postToWallitApi(
      `/orders/users/${userId}/userAttributes`,
      { userAttributes },
    ).toPromise().then((result) => {
      return result;
    });
  }

  completeCurrentOrder(userId: string): Promise<any> {
    return this.httpClient.postToWallitApi(
      `/orders/users/${userId}/completeCurrentOrder`,
      null,
    ).toPromise().then((orderId) => {
      return orderId;
    });
  }

  calculateOrderTotal(itemActions) {
    return <number>Object.values(itemActions).reduce((total: number, { amount }: {
      amount: number
    }) => total + (amount || 0), 0);
  }

  getCompletedOrders(userId: string): Promise<any> {
    return this.httpClient.getFromWallitApi(`/orders/users/${userId}/completed`)
      .toPromise()
      .then((orders: Array<any>) => {
        return orders.map((order) => {
          order.createdAt = new Date(order.createdAt);
          order.items = JSON.parse(order.items || null);
          order.itemActions = JSON.parse(order.itemActions || null);
          Object.keys(order.itemActions || {}).map((itemActionKey => {
            const itemAction = order.itemActions[itemActionKey];
            itemAction.amount = parseFloat(itemAction.amount || '0');
            return itemAction;
          }));
          order.amount = this.calculateOrderTotal(order.itemActions).toFixed(2);
          order.total = parseFloat(order.amount);
          order.userAttributes = JSON.parse(order.userAttributes || null);
          const employmentType = order.userAttributes?.employmentType || 'W2';
          order.adminFee = JSON.parse(order?.priceAdjustments || '[]')
            ?.find(fee => fee.employmentType === employmentType);
          if (order.adminFee?.amountCents) {
            order.adminFee.amountCents = parseFloat(order.adminFee.amountCents);
            order.total += (order.adminFee.amountCents / 100);
          }
          order.total = order.total?.toFixed(2);
          return order;
        });
      });
  }

  getCurrentOrder(userId: string, readFromCache: boolean = false): Promise<any> {
    if (readFromCache && this.order) {
      return Promise.resolve(this.order);
    }
    return this.httpClient.getFromWallitApi(`/orders/users/${userId}`)
      .toPromise()
      .then((order) => {
        order.items = JSON.parse(order.items || null);
        order.itemActions = JSON.parse(order.itemActions || null);
        Object.keys(order.itemActions || {}).map((itemActionKey => {
          const itemAction = order.itemActions[itemActionKey];
          itemAction.amount = parseFloat(itemAction.amount || '0');
          return itemAction;
        }));
        order.priceAdjustments = JSON.parse(order.priceAdjustments || null);
        order.userAttributes = JSON.parse(order.userAttributes || null);
        this.order = order;
        return order;
      });
  }

  // TODO: perhaps move into own file?
  getTagAlongProductIds(vendorId: string) {
    return this.httpClient.getFromWallitApi(`/tagAlongs/vendors/${vendorId}`)
      .toPromise()
      .then((tagAlongs) => {
        const tagAlongProductsMetadata = tagAlongs.length > 0 ? JSON.parse(tagAlongs[0]?.metadata || null) : {};
        return tagAlongProductsMetadata?.tagAlongVendorProductIds || [];
      });
  }

  removeFromCart(userId: string, vendorProductId: string): Promise<any> {
    return this.httpClient.deleteFromWallitApi(`/orders/users/${userId}/vendorProducts/${vendorProductId}`)
      .toPromise()
      .then((result) => {
        return result;
      });
  }
}
